import {Injectable} from "@angular/core";
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from "@angular/router";
import {Observable} from "rxjs/Rx";
import {UserService} from "../../services/user.service";


@Injectable()
export class BuyerAuthGuard implements CanActivate {

  constructor(private userService: UserService,
              private router: Router) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> |boolean {
    if(this.userService.isLoggedIn() && this.userService.isBuyer()) {
      return true;
    }
    localStorage.setItem("redirectUrl", state.url);
    this.router.navigateByUrl("/login");
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/buyer/buyer-auth-guard.ts